import LaskinPoplarData from "../../../../src/components/laskin-poplar-data.js";
import * as React from 'react';
export default {
  LaskinPoplarData,
  React
};